import api from '../api'
import { toast } from 'react-toastify'

export const loginUser = async (userData) => {
    const response = await api.post('/login', userData)
    const data = response.data

    if (data.error) {
        throw data
    }

    // Store auth data
    // localStorage.setItem('authToken', data.user.authToken)

    return data
}

export const login = async (userData) => {
    const response = await api.post('/login', userData)
    const data = response.data

    if (data.error) {
        throw data
    }

    // Store auth data
    localStorage.setItem('authToken', data.user.authToken)
    return data
}


export const loginUserWithToken = async (authToken) => {
    const response = await api.post('/login-with-token')
    return response.data
}

export const getRedirectPath = (role) => {
    switch (role) {
        case 'student':
            return '/student'
        case 'teacher':
            return '/teacher'
        case 'school':
            return '/school'
        case 'guardian':
            return '/guardian'
        default:
            return '/'
    }
} 

export const saveDeviceToken = async (token) => {
    const response = await api.post('/save-device-token', { device_token:token });
    return response.data
}